<script>
  export default {
    data() {
      return {
        currentFadeSlide: 1,
        fadeSlides: 6,
        currentPanelSlide: 1,
        panelSlides: 3,
        panelSlidesHeight: 0,
        currentModal: null,
        isModalActive: false
      }
    },
    created() {
      this.fadeSlidePlay(6000);
    },
    mounted() {
      window.addEventListener('load', () => {
        this.panelSlidePlay(4000);
      });
      if (window.matchMedia("min-width: 1281px")) {
        this.panelSlideImageHeight();
        window.addEventListener('resize', () => {
          this.panelSlideImageHeight();
        });
      }
    },
    methods: {

      // panel slide
      panelSlidePlay(duration) {
        window.setInterval(() => {
          if(this.currentPanelSlide < this.panelSlides) {
            this.currentPanelSlide++;
          } else {
            this.currentPanelSlide = 1;
          }
        }, duration);
      },
      panelSlideImageHeight() {
        const heights = Array.prototype.slice.call(document.querySelectorAll('.js-panel-slide-image')).map((image) => {
          return image.clientHeight
        });
        this.panelSlidesHeight = Math.max(...heights);
      },

      // fade slide
      fadeSlidePlay(duration) {
        window.setInterval(() => {
          if(this.currentFadeSlide < this.fadeSlides) {
            this.currentFadeSlide++;
          } else {
            this.currentFadeSlide = 1;
          }
        }, duration);
      },
      fadeSlidePager(order) {
        this.currentFadeSlide = order;
      },

      // modal
      showModal(number) {
        this.currentModal = number;
        this.isModalActive = true;
      },
      closeModal() {
        this.isModalActive = false;
        this.currentModal = null;
      }
      
    }
  }
</script>

